import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Combobox, Panel } from '@mairistem/finances-utils';
import { isNull, isString, isUndefined } from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import { createTravauxRegie } from '../../../services/piecesComptables/travauxRegie';
import CustomCheckbox from '../../Common/CustomCheckbox';
import './TravauxEnRegieComponent.css';

const TravauxEnRegieComponent = ({
	data,
	handlePin,
	onChange,
	panel,
	setPanelOptions,
}: PanelComponentProps) => {
	const handleAddProduit = async (
		_e: React.SyntheticEvent,
		{ name, value }: { name: string; value: string },
	) => {
		try {
			const travauxRegieData = await createTravauxRegie({ libelle: value });

			setPanelOptions((old) => ({
				...old,
				travauxEnRegie: [
					...old.travauxEnRegie,
					{
						text: travauxRegieData.libelle,
						value: travauxRegieData.identifiant,
						key: travauxRegieData.identifiant,
						'data-testid': `travauxRegieOption${travauxRegieData?.identifiant}`,
					},
				],
			}));
			onChange?.({ [name]: travauxRegieData?.identifiant }, panel);
		} catch {
			toast.error('Impossible de récupérer les travaux en régies');
		}
	};

	const handleChange = (_e: React.SyntheticEvent, { name }: { name: string }) =>
		onChange?.({ [name]: !data?.cocheTravauxRegie }, panel);

	const handleChangeLibelleProduit = (
		_e: React.SyntheticEvent,
		{ name, value }: { name: string; value: unknown },
	) => {
		if (!isString(value)) onChange?.({ [name]: value }, panel);
	};

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group>
					<Form.Input
						checked={data?.cocheTravauxRegie}
						className="travauxRegieCheckbox"
						control={CustomCheckbox}
						data-testid="travauxRegieCheckbox"
						indeterminate={
							isUndefined(data?.cocheTravauxRegie)
								? false
								: !!isNull(data?.cocheTravauxRegie)
						}
						label="A immobiliser"
						name="cocheTravauxRegie"
						onChange={handleChange}
						width={5}
					/>
					<Form.Field
						additionLabel="Ajouter "
						allowAdditions
						control={Combobox}
						data-testid="travauxRegieDropdown"
						disabled={!data?.cocheTravauxRegie}
						key="identifiantTravauxRegie"
						label="Produit"
						name="identifiantTravauxRegie"
						onAddItem={handleAddProduit}
						onChange={handleChangeLibelleProduit}
						options={data?.travauxEnRegie ?? []}
						placeholder={data?.identifiantTravauxRegie === MULTI ? MULTI : ''}
						search
						selection
						value={data?.identifiantTravauxRegie ?? null}
						width={11}
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default TravauxEnRegieComponent;
